import i18n from "config/i18next";

i18n.addResources("es", "slots", {
  display: "Visualización",
  templates: "Plantillas",
  slots: "Turnos",
});
